import normalizeJsonApi from '../../shared/utilities/jsonApiNormalizer';

import { formatDateTime } from '../../shared/utilities/date';

import { Notification, NotificationFromAPI, NotificationJSONAPIResponse } from './types';

const notificationSerializer = (notification: NotificationFromAPI): Notification =>
    ({
        id: notification.id,
        type: notification.attributes.eventName,
        occurredOn: formatDateTime(notification.attributes.occurredOn),
        subscriberId: notification.attributes.subscriberId,
        read: notification.attributes.read,
        dossierId: notification.attributes.dossierId,
        requesterName: notification.attributes.requesterName,
        enrichedData: notification.attributes.enrichedData,
    }) as Notification;

export const serializeNotificationArrayFromAPI = (
    json: NotificationJSONAPIResponse,
): Notification[] => {
    const { notification: notifications } = normalizeJsonApi<{
        notification: { [key: string]: NotificationFromAPI };
    }>(json);
    return notifications ? Object.values(notifications).map(notificationSerializer) : [];
};
